module.exports = __webpack_public_path__ + "static/media/MarsLogo.312659b9.svg";